import React from 'react';

import { cn } from '../../lib/utils';

const SettingsButton = React.forwardRef(({ children, className = '', variant = 'primary', ...props }, ref) => {
  const variantStyles = {
    primary:
      'border border-black bg-black text-white hover:bg-gray-800 dark:border-neutral-700 dark:bg-neutral-700 dark:text-white dark:hover:bg-neutral-800',
    secondary:
      'border border-gray-300 text-gray-500 hover:bg-gray-200 dark:border-neutral-700 dark:text-neutral-500 dark:hover:border-neutral-500',
    action: 'bg-gray-200 text-gray-600 hover:bg-gray-300 dark:bg-neutral-500 dark:text-neutral-300 dark:hover:bg-neutral-600',
    danger: 'bg-red-600 text-white hover:bg-red-700',
    link: 'px-0 py-0 text-xs font-semibold text-blue-600 underline hover:text-blue-700',
  };

  // "text-cursed" was being swallowed up for some reason, if it's not marked as important
  return (
    <button
      {...props}
      ref={ref}
      data-app-region="none"
      className={cn(
        'cursor-pointer rounded-xl px-4 py-3.5 !text-cursed/5 font-medium disabled:cursor-not-allowed disabled:opacity-50',
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </button>
  );
});

SettingsButton.displayName = 'SettingsButton';

export default SettingsButton;
